import React from "react";

interface SectionLoadingOverlayProps {
  label: string;
}

const SectionLoadingOverlay: React.FC<SectionLoadingOverlayProps> = ({ label }) => {
  return (
    <div className="admin-page__loading-overlay" aria-live="polite" aria-busy="true">
      <div className="admin-page__loading-overlay-card">
        <div className="admin-page__loading-spinner" />
        <span>{label}</span>
      </div>
    </div>
  );
};

export default SectionLoadingOverlay;